import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareSummaryClassicRoute: InvariantJiraRoute = {
	name: 'software-summary-classic',
	path: '/jira/software/c/projects/:projectKey/summary',
};
